"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.regexp.to-string");
var _defineProperty2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _vuex = require("vuex");
var _Breadcrumb = _interopRequireDefault(require("@/components/Breadcrumb"));
var _Hamburger = _interopRequireDefault(require("@/components/Hamburger"));
var _index = require("@/utils/index");
var _auth = require("@/utils/auth");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    Breadcrumb: _Breadcrumb.default,
    Hamburger: _Hamburger.default
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)(['sidebar', 'avatar'])), {}, {
    agentInfo: function agentInfo() {
      var agentInfo = this.$store.state.user.agentInfo;
      if (this.checkRoles(['partner']) && agentInfo.id) this.getConfigs();
      return agentInfo;
    },
    siteInfo: function (_siteInfo) {
      function siteInfo() {
        return _siteInfo.apply(this, arguments);
      }
      siteInfo.toString = function () {
        return _siteInfo.toString();
      };
      return siteInfo;
    }(function () {
      return siteInfo;
    })
  }),
  data: function data() {
    return {
      updateWxxcx: false,
      updateAlixcx: false,
      token1: (0, _auth.getToken)('token1') || ''
    };
  },
  mounted: function mounted() {},
  methods: {
    /**
     * 获取列表
     */
    getConfigs: function getConfigs() {
      var _this = this;
      this.$get('WxOpen/getConfigs', {
        tag: 'wm01'
      }).then(function (res) {
        _this.getWxxcx(res['wm010001']);
        _this.getAlixcx(res['wm010006']);
      });
    },
    /**
     * 获取微信小程序列表
     */
    getWxxcx: function getWxxcx(template_id) {
      var _this2 = this;
      this.$get('WxOpen/getWxList', {
        page: 1,
        limit: 10,
        wx_status: 1
      }).then(function (res) {
        var list = res.list;
        for (var i = 0; i < list.length; i++) {
          if (list[i].mini_info.latest_code != template_id || list[i].mini_info.option_status != 6) {
            _this2.updateWxxcx = true;
            break;
          }
        }
      });
    },
    /**
     * 获取支付宝小程序列表
     */
    getAlixcx: function getAlixcx(template_version) {
      var _this3 = this;
      this.$get('AlipayMini/getConfigList', {
        page: 1
      }).then(function (res) {
        var list = res.list;
        for (var i = 0; i < list.length; i++) {
          if (list[i].app_name.indexOf('模版') == -1 && (list[i].templateInfo.template_version != template_version || list[i].templateInfo.status != 'RELEASE')) {
            _this3.updateAlixcx = true;
            break;
          }
        }
      });
    },
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    logout: function () {
      var _logout = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return this.$store.dispatch('user/logout');
            case 1:
              location.href = '/login/' + agentInfo.id;
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function logout() {
        return _logout.apply(this, arguments);
      }
      return logout;
    }(),
    /**
     * 返回总后台
     */
    toAdmin: function toAdmin() {
      (0, _auth.setToken)(this.token1);
      (0, _auth.setToken)(this.config.admin_id, 'user_id');
      (0, _auth.setToken)(this.config.admin_id, 'agent_id');
      (0, _auth.removeToken)('token1');
      (0, _auth.removeToken)('server_permission_menus');
      (0, _auth.removeToken)('server_permission_roles');
      (0, _auth.setPermission)((0, _auth.getPermission)('server_permission1'), 'server_permission_menus');
      (0, _auth.setPermission)((0, _auth.getPermission)('server_permission_roles1'), 'server_permission_roles');
      setTimeout(function () {
        location.href = '/home';
      }, 100);
    }
  }
};